import React, { Component } from 'react';
import Translator from '../../../core/i18n';
import { IAppState, IAction } from '../../../models/action/core';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../store/actions/coursePage';
import { Common } from '../../../core/common';
import CCourseContentWeeks from '../../../components/lesson/course-content-weeks/main';
import ICourseContentMenu from '../../../models/components/course-content-menu';
import Loading from '../../loading/loading';
import ContentLoader from 'react-content-loader';
import ProgressPercent from './progressPercent';
import { UserType } from '../../../models/enums/userType';
import { Log } from 'ng2-logger';
import { GetActivitiesType } from '../../../models/enums/GetActivityType';
import { CourseContentMenuType } from '../../../models/enums/CourseContentMenuType';
import { Modal, ModalBody } from 'reactstrap';
import { CourseDefaultViewType } from '../../../models/enums/CourseDefaultViewType';
import { Badge } from 'react-bootstrap';
import ProgressCircleLargeSidebar from '../../progress-circle/progress-circle-large-sidebar';
import HeaderOptionss from '../../../pages/main-navigation/header-optionss';
import { enrollmentStatus } from '../../../models/enums/enrollmentStatus';
import Tooltip from '../../tooltip/main';

let _common: Common;
const _logger = Log.create('vertical_menu');
const T = Translator.create();

class CourseContentSelectionMenu extends React.Component<ICourseContentMenu> {
    state = {
        isOpenModalAdd: false,
        modalVisible: false
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
        this.setCloseAddModal = this.setCloseAddModal.bind(this);
        this.addNewActivityModal = this.addNewActivityModal.bind(this);

    }

    public setCloseAddModal() {
        this.setState({ isOpenModalAdd: false, modalVisible: false });
    }

    public addNewActivityModal() {
        this.setState({ isOpenModalAdd: true, modalVisible: true });
    }

    public resetState = () => {
        // this.props.dispatch(Actions.getCourseContentMenu(this.props.coursePageClassId!, false));
    }

    public moveActivity = () => {
        const movementOptions = document.getElementsByClassName('movement_options');
        if (movementOptions) {
            for (let i = 0; i < movementOptions.length; i++) {
                movementOptions[i].classList.remove('d-none');
            }
        }

        const movementButtons = document.getElementsByClassName('movement_buttons');
        if (movementButtons) {
            for (let i = 0; i < movementButtons.length; i++) {
                movementButtons[i].classList.remove('d-none');
            }
        }
    };

    countActivities = () => {
        let model = {
            completedActivityCounts: 0,
            activityCounts: 0
        };

        if (this.props.activityIdsByWeeks && this.props.activityIdsByWeeks.length > 0 && this.props.activityIdsByWeeks[0].activitiesByWeek) {
            if (this.props.activityIdsByWeeks && this.props.activityIdsByWeeks[0].notWeekly === true) {
                if (this.props.courseContentWeeksActivities) {
                    this.props.courseContentWeeksActivities.forEach(activity => {
                        model.activityCounts++;
                        model.completedActivityCounts = this.returnCompletedActivityCount(activity, model.completedActivityCounts);
                    });
                }
            } else {
                this.props.activityIdsByWeeks.forEach((weeks: any) => {
                    weeks.activitiesByWeek.forEach((activity: any) => {
                        model.activityCounts++;
                        model.completedActivityCounts = this.returnCompletedActivityCount(activity, model.completedActivityCounts);
                    });
                });
            }
        }
        return model
    }

    returnCompletedActivityCount = (activity: any, complatedActivityCounts: number) => {
        if (this.props.enrollmentData) {
            let filteredActivities = this.props.enrollmentData.filter(f => f.activityId === activity.activityId);
            let completedStatus = enrollmentStatus.NotStarted;
            if (filteredActivities.length > 0) {
                completedStatus = filteredActivities[0].status;
            }

            if (completedStatus === enrollmentStatus.Completed && this.props.userType === UserType.Student) {
                complatedActivityCounts++;
            }
        } else {
            complatedActivityCounts = 0;
        }
        return complatedActivityCounts;
    }

    public render() {
        const loadingSpaces = 60;
        let activityCounts: number = 0;
        let complatedActivityCounts: number = 0;
        let activityCountsModel = this.countActivities();

        complatedActivityCounts = activityCountsModel.completedActivityCounts;
        activityCounts = activityCountsModel.activityCounts;
        return (
            <>
                {
                    this.props.showMobile ?
                        <div>

                            <button style={{ background: 'none', border: 'none' }} onClick={this.addNewActivityModal} >
                                <img src={_common.GetDefaultIcons('week')} style={{ width: '24px', margin: '0' }} alt="icon" />
                            </button>
                        </div>
                        :
                        <div className="tab-content pt-0 animated fadeIn course_header_none">
                            <div className="tab-pane fade active show" style={{ display: 'flex' }} id="courseContent" role="tabpanel" aria-labelledby="courseContent-tab">
                                <div className="content-container" style={{ display: 'flex', height: "calc(100vh - 145px)" }}>
                                    <div id="myScrollspy" className="main-sidebar" style={{ display: "block" }}>
                                        <li className={'d-flex align-items-center justify-content-between header-top shadow-3'} style={{ zIndex: '53', position: 'relative' }}>
                                            <div className='row' style={{ marginTop: '0px', width: '400px' }}>

                                                <div className='col-md-9' style={{ marginTop: '5px', display: 'flex' }}>
                                                    <span className="mb-0 lms-header-medium" tabIndex={0}>{T.t('r_syllabus')}</span>
                                                    {
                                                        this.props.showMobile &&
                                                        <span style={{ marginInlineStart: '2px' }}>
                                                            <Badge pill={true} variant="light" style={{ backgroundColor: '#d9dadc', fontWeight: 600, fontSize: '10px', color: 'black' }} tabIndex={0}>
                                                                {activityCounts}
                                                            </Badge>
                                                        </span>
                                                    }

                                                </div>
                                                <div className='col-md-2'> {this.props.userType && this.props.userType === UserType.Student ?
                                                    <Tooltip data={T.t('r_completed_all') + ": %" + (this.props.progress ?? 0)} position={document.body.getAttribute('dir') == 'ltr' ? 'left' : 'right'}>
                                                        {
                                                            !this.props.showMobile &&
                                                            <span tabIndex={0}>
                                                                <ProgressCircleLargeSidebar width={34} height={34} total={activityCounts} count={complatedActivityCounts} />
                                                            </span>
                                                        }
                                                    </Tooltip>
                                                    :


                                                    <Tooltip position={document.body.getAttribute('dir') == 'ltr' ? 'left' : 'right'} data={`${T.t('r_activity_count')}:${activityCounts}`}>
                                                        {!this.props.showMobile &&
                                                            <Badge pill={true} variant="light" style={{ backgroundColor: '#d9dadc', fontWeight: 600, fontSize: '10px', color: 'black' }} tabIndex={0}>
                                                                {activityCounts}
                                                            </Badge>}
                                                    </Tooltip>
                                                }</div>
                                            </div>
                                            <HeaderOptionss />
                                            <div>
                                                {/* TO DO: Left Menu Item Moving
                                                    <a data-toggle="dropdown" href="javasciprt:;" aria-expanded="false">
                                                        <img className="float-right" src={_common.GetDefaultIcons('dots')} alt="Icons" />
                                                    </a> */}
                                                <div
                                                    className="dropdown-menu dragdropdown"
                                                    aria-labelledby="dropdownMenuButton"
                                                    x-placement="bottom-start"
                                                >
                                                    <a className="dropdown-item" onClick={this.moveActivity}  >
                                                        {T.t('r_activity_move')}
                                                    </a>
                                                </div>
                                            </div>
                                        </li>
                                        {this.props.courseDefaultView && this.props.courseDefaultView !== CourseDefaultViewType.List ?
                                            <Loading spinnerId={'getCourseContentMenu'}>
                                                <div style={{ backgroundColor: '#eeede9' }}>
                                                    <ContentLoader
                                                        speed={2}
                                                        backgroundColor="#f3f3f3"
                                                        foregroundColor="#ecebeb"
                                                        viewBox="0 0 360 800"
                                                        style={{ width: '100%' }}
                                                    >
                                                        <rect x="5" y="5" rx="0" ry="0" width="350" height="70" />
                                                        <rect x="5" y="85" rx="0" ry="0" width="350" height="50" />
                                                        <rect x="5" y={85 + loadingSpaces} rx="0" ry="0" width="350" height="50" />
                                                        <rect x="5" y={85 + loadingSpaces * 2} rx="0" ry="0" width="350" height="50" />
                                                        <rect x="5" y={85 + loadingSpaces * 3} rx="0" ry="0" width="350" height="50" />
                                                        <rect x="5" y={85 + loadingSpaces * 4} rx="0" ry="0" width="350" height="50" />
                                                        <rect x="5" y={85 + loadingSpaces * 5} rx="0" ry="0" width="350" height="50" />
                                                        <rect x="5" y={85 + loadingSpaces * 6} rx="0" ry="0" width="350" height="50" />
                                                        <rect x="5" y={85 + loadingSpaces * 7} rx="0" ry="0" width="350" height="50" />
                                                        <rect x="5" y={85 + loadingSpaces * 8} rx="0" ry="0" width="350" height="50" />
                                                        <rect x="5" y={85 + loadingSpaces * 9} rx="0" ry="0" width="350" height="50" />
                                                        <rect x="5" y={85 + loadingSpaces * 10} rx="0" ry="0" width="350" height="50" />
                                                    </ContentLoader>
                                                </div>
                                            </Loading>
                                            : null
                                        }
                                        {
                                            (this.props.courseContentMenuType) ?
                                                (
                                                    <CCourseContentWeeks showMobile={this.props.showMobile} closeModal={this.setCloseAddModal} isOpenModalAdd={this.state.isOpenModalAdd} modalVisible={this.state.modalVisible} />
                                                ) : ('')
                                        }
                                        {this.props.userType === UserType.Student ?
                                            < ProgressPercent classId={this.props.coursePageClassId} userId={this.props.identity.userId} />
                                            : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                }
                {
                    (this.props.courseContentMenuType && this.props.showMobile) ?
                        (
                            <CCourseContentWeeks showMobile={this.props.showMobile} closeModal={this.setCloseAddModal} isOpenModalAdd={this.state.isOpenModalAdd} modalVisible={this.state.modalVisible} />
                        ) : ('')
                }
            </>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICourseContentMenu): ICourseContentMenu => {
    if (!state) {
        return ownProps;
    }
    const newProps: ICourseContentMenu = Object.assign({}, ownProps, {
        // courseContentMenuLoading: state.coursePage.courseContentMenuLoading,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        activityFilters: state.coursePage.activityFilters,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        actId: state.coursePage.actId,
        homePageSelectedTab: state.coursePage.homePageSelectedTab,
        identity: state.login.identitiy,
        userType: state.login.identitiy.userType,
        courseDefaultView: state.coursePage.courseDefaultView,
        activityIdsByWeeks: state.coursePage.activityIdsByWeeks,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        enrollmentData: state.enrollment.enrollmentData,
        progress: state.coursePage.progress ? state.coursePage.progress : '0'
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView &&
        next.coursePage.courseContentMenuType === prev.coursePage.courseContentMenuType &&
        next.coursePage.activityIdsByWeeks === prev.coursePage.activityIdsByWeeks
    );
    return ret;
};

const CCourseContentSelectionMenu = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CourseContentSelectionMenu);

export default CCourseContentSelectionMenu;